import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { BUILDING_MANAGER } from '../../constants';

export default function ({ building }) {
  const hasRole = building.Roles.includes(BUILDING_MANAGER);
  const { t } = useTranslation();

  if (!hasRole) {
    return null;
  }

  return (
    <Button
      to={`/app/buildings/${building.id}/companies`}
      component={Link}
      variant="outlined"
      color="primary"
      size="small"
      fullWidth
      style={{ marginTop: '5px' }}
    >
      {t('Companies')}
    </Button>
  );
}
